import * as React from 'react';

/**
 * The props for the ColumnInput component
 */
export interface ColumnInputProps {
    /**
     * If the column is currently active
     */
    active: boolean;
    /**
     * The column's name/default header
     */
    name: string;
    /**
     * If the column is required
     */
    required: boolean;
    /**
     * Change handler to invoke when the checkbox is checked/unchecked
     */
    onChange: (checked: boolean) => void;
}

/**
 * This component is the checkbox group for a given column
 * @param props The props for this component
 */
export function ColumnInput(props: ColumnInputProps) {
    const userSelect = getUserSelect(props.active);
    return (
        <div style={{ display: 'inline-block', margin: 8 }}>
            <input
                id={'column-' + props.name}
                type="checkbox"
                checked={props.active}
                onChange={event => props.onChange(event.currentTarget.checked)}
                style={{ marginBottom: 0, msUserSelect: 'none' }}
                disabled={props.required}
            />
            <label
                htmlFor={'column-' + props.name}
                style={{
                    userSelect,
                    msUserSelect: props.active ? 'none' : 'text',
                    MozUserSelect: userSelect,
                    WebkitUserSelect: userSelect,
                    cursor: 'pointer'
                }}
            >
                {props.name + (props.required ? ' (Required)' : '')}
            </label>
        </div>
    );
}

/**
 * Do not allow the labels/checkbox to be selected as it
 * interferes with sorting
 * @param active If the column is active
 */
const getUserSelect = (active: boolean) => (active ? 'none' : 'auto');
